import React, { useRef } from 'react';
import { BsFunnel } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FilterLabel from '../../../../components/FilterLabel';
import FilterRadioGroup from '../../../../components/FilterRadioGroup';
import { analyticsIds } from '../../../../constants/analyticsIds';
import {
  clearInsuredListFilters,
  selectInsuredListFilters,
  setInsuredListInsuredNameOrder
} from '../../../../redux/modules/insuredList';

const InsuredListFilters = ({ searchBlueprint }) => {
  const dispatch = useDispatch();
  const initRef = useRef();
  const { insuredCompanyNameOrder } = useSelector(selectInsuredListFilters);

  const handleClearFilters = () => {
    dispatch(clearInsuredListFilters());
  };

  return (
    <Popover
      initalFocusRef={initRef}
      placement="left-start"
    >
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger>
            <IconButton
              aria-label="Insured List Filters"
              data-analytics-id={analyticsIds.insuredsListPage.filterInsuredsButton}
              icon={<Icon as={BsFunnel} boxSize="24px" />}
              mr={4}
              variant="accent"
            />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader px={6} py={4} textAlign="left">
              <Text color="greyScale.900" textStyle="bodyXxl500">
                Filters
              </Text>
            </PopoverHeader>
            <PopoverBody pb={4} px={6} width="395px">
              <Box maxH="700px" overflow="auto" pb={3} pt={1} textAlign="left">
                <Box my={2}>
                  <FilterLabel labelName="Insured Name" />
                  <Box>
                    <FilterRadioGroup
                      value={insuredCompanyNameOrder}
                      onChange={value => {
                        dispatch(searchBlueprint.updateSortBy([{
                          id: 'insured',
                          desc: (value === 'desc')
                        }]));

                        dispatch(setInsuredListInsuredNameOrder(value));
                      }}
                    />
                  </Box>
                </Box>
                <Flex flexFlow="row nowrap" justifyContent="center" mt={6}>
                  <Button
                    data-analytics-id={analyticsIds.insuredsListPage.clearInsuredsFilterButton}
                    mx={1}
                    variant="secondary"
                    onClick={handleClearFilters}
                  >
                    Reset Filters
                  </Button>
                  <Button
                    data-analytics-id={analyticsIds.insuredsListPage.applyInsuredsFilterButton}
                    mx={1}
                    variant="primary"
                    onClick={onClose}
                  >
                    Show Results
                  </Button>
                </Flex>
              </Box>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

InsuredListFilters.propTypes = { searchBlueprint: PropTypes.shape({ updateSortBy: PropTypes.func }) };

export default InsuredListFilters;
